import { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { isEmpty } from 'lodash/fp';

import { ROUND_ID_KEY } from '@portal/common/models/data-key';
import { DataProjectId } from '@portal/common/models/data-project';

import config from '../../config';
import { getDataCollections } from '../../store/data-explorer/selectors';
import {
    getIsImpersonatedSession,
    getIsNotificationShown,
    getIsStealthUser,
    getSessionAccountId,
} from '../../store/session/selectors';
import AppSurvey from '../AppSurvey';
import NewGBDBecomesDefaultPopup from '../popups/NewGBDBecomesDefaultPopup';

const AppNotifications = () => {
    const accountId = useSelector(getSessionAccountId);
    const isImpersonated = useSelector(getIsImpersonatedSession);
    const isStealth = useSelector(getIsStealthUser);
    const isNotificationDismissed = useSelector(getIsNotificationShown);
    const dataCollections = useSelector(getDataCollections);

    const isUserLicensedToGBD = useMemo(() => {
        if (isEmpty(dataCollections)) return false;

        const gbdCollections = dataCollections.filter(
            (c) => c.data_project_id === DataProjectId.GBD
        );
        if (isEmpty(gbdCollections)) return false;

        return !!gbdCollections.find((collection) =>
            collection.datasets.find(({ granularity }) =>
                (granularity?.[ROUND_ID_KEY] || []).includes(config.gbd2023RoundId)
            )
        );
    }, [dataCollections]);

    const isNewGBDBecomesDefaultPopupShown =
        Boolean(accountId) &&
        !isImpersonated &&
        !isStealth &&
        !isNotificationDismissed &&
        isUserLicensedToGBD;

    if (isNewGBDBecomesDefaultPopupShown) {
        return <NewGBDBecomesDefaultPopup />;
    }
    return <AppSurvey />;
};

export default AppNotifications;
